import {Stack, Text} from '@mantine/core';
import React from 'react';

export const NO_MODELS_INSTALLED_TITLE = 'No AI models installed';
export const NO_MODELS_INSTALLED_DESCRIPTION = 'Contact your tenant administrator to install AI models.';

/** Combined single-line message for surfaces that show a banner rather than a full empty state. */
export const NO_MODELS_INSTALLED_BANNER_MESSAGE = `${NO_MODELS_INSTALLED_TITLE}. ${NO_MODELS_INSTALLED_DESCRIPTION}`;

export default function NoModelsInstalledEmptyState(): JSX.Element {
  return (
    <Stack align="center" spacing="xs" mt="xl">
      <Text size="lg" weight={600}>
        {NO_MODELS_INSTALLED_TITLE}
      </Text>
      <Text color="dimmed">{NO_MODELS_INSTALLED_DESCRIPTION}</Text>
    </Stack>
  );
}
